var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOuterlink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F\\u5907\\u4EFD-7",
    transform: "translate(-667.000000, -1122.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-17",
    transform: "translate(480.000000, 586.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-15",
    transform: "translate(84.000000, 531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fenxiang",
    transform: "translate(103.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58333333,0 L7.08333333,0 C6.85321469,0 6.66666667,0.186548021 6.66666667,0.416666667 C6.66666667,0.646785312 6.85321469,0.833333333 7.08333333,0.833333333 L8.578125,0.833333333 L4.70572917,4.70572917 C4.62748777,4.78367051 4.58350689,4.88956192 4.58350689,5 C4.58350689,5.11043808 4.62748777,5.21632949 4.70572917,5.29427083 C4.78367051,5.37251223 4.88956192,5.41649311 5,5.41649311 C5.11043808,5.41649311 5.21632949,5.37251223 5.29427083,5.29427083 L9.16666667,1.42317708 L9.16666667,2.91666667 C9.16666667,3.14678531 9.35321469,3.33333333 9.58333333,3.33333333 C9.81345198,3.33333333 10,3.14678531 10,2.91666667 L10,0.416666667 C10,0.186548021 9.81345198,0 9.58333333,0 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58333333,4.58333333 C9.35321469,4.58333333 9.16666667,4.76988135 9.16666667,5 C9.16666667,7.30118646 7.30118646,9.16666667 5,9.16666667 C2.69881354,9.16666667 0.833333333,7.30118646 0.833333333,5 C0.833333333,2.69881354 2.69881354,0.833333333 5,0.833333333 C5.23011865,0.833333333 5.41666667,0.646785312 5.41666667,0.416666667 C5.41666667,0.186548021 5.23011865,0 5,0 C2.23857625,0 0,2.23857625 0,5 C0,7.76142375 2.23857625,10 5,10 C7.76142375,10 10,7.76142375 10,5 C10,4.76988135 9.81345198,4.58333333 9.58333333,4.58333333 Z",
    id: "\\u8DEF\\u5F84"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuterlink);
export default __webpack_public_path__ + "static/media/outerlink.79f0c976fdd194ecfb9c85bb0a6ca360.svg";
export { ForwardRef as ReactComponent };